import { transform } from './transform';

/**
 * Generate object that contains assertions that media type is within each breakpoint
 * @arg {currentMediaType} breakpoints - The curent media type.
 * @arg {object} breakpoints - The breakpoints object.
 * @returns {object} The `is` object.  Its keys are the same as the
 * keys of the breakpoints object.  The value for each key indicates whether
 * or not the browser width is less than the breakpoint.
 */
export function assertMediaTypeIs(currentMediaType, breakpoints) {
  return transform(breakpoints, function (result, breakpoint, mediaType) {
    // store whether or not the current media type matches the breakpoint in the mapping
    result[mediaType] = mediaType === currentMediaType;
  });
}